import { z } from 'zod';
import { ScoreBand, TimestampLike } from './common.js';

export const ScorecardDoc = z.object({
  asOf: TimestampLike,
  healthScore: z.number().min(0).max(100),
  scoreBand: ScoreBand,
  trend30Day: z.number(),
  trend90DaySparkline: z.array(z.number()).length(12),
  // Per-week historical counts of page-1 negative / positive URLs over the
  // last 12 weeks. Populated by recomputeScorecard from rankings history.
  // Optional for backward compat — older scorecards predating Phase 13a
  // won't have these and the Portal renders a flat line until the next
  // trigger fire repopulates them.
  negativesPage1Sparkline: z.array(z.number().int().min(0)).length(12).optional(),
  positivesPage1Sparkline: z.array(z.number().int().min(0)).length(12).optional(),
  negativesOnPage1: z.number().int().min(0),
  positivesOnPage1: z.number().int().min(0),
  previousPeriod: z.object({
    negativesOnPage1: z.number().int().min(0),
    positivesOnPage1: z.number().int().min(0),
    healthScore: z.number().min(0).max(100),
  }),
  lastPullAt: TimestampLike.optional(),
});
export type ScorecardDoc = z.infer<typeof ScorecardDoc>;
